<template>
  <div class="modal-dialog" id="upload_material">
    <div class="modal-content upload-material-pop">
      <div class="modal-body">
        <button type="button" class="close resource-close" @click="closeEditMaterial()">
          &times;
        </button>

        <p class="create-an-announcement">{{ title }}</p>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 upload-material">
          <div>
            <div class="pb-3">
              <img src="@/assets/file-upload1.png" class="upload-file-img" />
            </div>
            <div class="drag-file-text">
              <span>Drag and drop your file here.</span>
            </div>
            <label for="filePhoto" class="btn upload-file-text">Or upload a file</label>
            <input type="file" id="filePhoto" @change="editMaterialFiles" />
          </div>

          <span class="editfile_name" v-if="fileName"
            >{{ fileName.slice(0, 35) }}
            <a v-if="fileName.length > 35">....</a>
          </span>
          <br />
          <div class="acceptable-file-types">
            <span>Acceptable file types: .pdf, .docx, .xlsx, .png, .jpg, .jpeg, .mp4.</span>
          </div>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 top-padding">
          <label class="links-label">Name</label><label class="edit-material-star">*</label><label class="edit-material-char-limit">Char limit 200 chars</label>
          <input type="text" @change="getMaterialName" v-on:keyup="validateName(editMaterial.name)" name="links-title" v-validate="'required'" :class="materialName == true ? 'is-danger' : 'is-success'" class="form-control links-title-box" v-model="editMaterial.name" placeholder="Enter filename" required />
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 top-padding" v-if="(canSysAdminAccess || canStudyAdminAccess || canSupportAccess) && siteDataLoaded === true">
          <label class="links-label">Select Sites</label><label class="edit-material-star">*</label>
          <multiSelectSearch :sitesData="sites" ref="childComponent" v-on:changeSites="updateData($event)" v-on:setSitesdata="getSitesCount($event)"> </multiSelectSearch>
        </div>

        <div class="material-cancel-add">
          <button type="button" class="btn material-cancel-btn" @click="closeEditMaterial()">
            Cancel
          </button>
          <button type="button" class="btn material-add-btn" v-on:click="uploadMaterialData(editMaterial)">
            Add
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import multiSelectSearch from "./multi-select-search";
import { mapGetters } from "vuex";
import $ from "jquery";
import { SYSTEM_ADMIN, STUDY_ADMIN, SUPPORT } from "@/constants/authRoles";
import { AclRule } from "vue-acl";
import localStorageService from "@/services/localStorage";

export default {
  name: "UploadMaterialPopUp",
  components: { multiSelectSearch },
  props: ["title", "isEdit"],
  data() {
    return {
      xmlHTTP: "",
      siteDataLoaded: false,
      editMaterial: {
        name: "",
        file: "",
        siteName: [],
        allSitesSelected: false
      },

      sites: [],
      validFileSize: true,
      fileExtensionType: "",
      validFileType: true,
      fileName: "",
      filePath: "",
      fileType: "",
      validmaterialNameValue: false,
      materialName: false,
      resourceListFlag: true,
      isFileSelected: false,
      selected: "Select Sites",
      isSiteSelected: false,
      selectedSitesCount: 0,
      piRoleName: "",
      piRoleUniqueId: "",
      studyId: this.$route.params.studyId,
      sitedata: []
    };
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    }
  },
  created() {
    this.getSitesdata();
    this.$root.$on("resources_data_list", resourceData => {
      if (resourceData == 0) {
        this.resourceListFlag = true;
      } else {
        this.resourceListFlag = false;
      }
    });
  },
  mounted() {
    this.getParticularPIrole();
  },
  methods: {
    getMaterialName(event) {
      this.editMaterial.name = event.target.value;
    },
    sortSites(a, b) {
      if (a.display_name < b.display_name) {
        return -1;
      } else if (a.display_name > b.display_name) {
        return 1;
      } else {
        return 0;
      }
    },
    async getSitesdata() {
      let sitesdata = [];
      const sitesArray = [];
      await this.$api.getSitesData(this.studyId).then(response => {
        if (response.body) {
          // sitesdata = response.body;
          sitesdata = response.body.sort(function(a, b) {
            return a.userSiteId.localeCompare(b.userSiteId, undefined, {
              numeric: true,
              sensitivity: "base"
            });
          });
        }
      });

      await sitesdata.map(el => {
        const siteObject = {
          name: "",
          id: "",
          check: false,
          values: []
        };
        const values = {
          display_name: "",
          data_id: "",
          check: false
        };

        //country data
        siteObject.name = el.countryList[0].countryName;
        siteObject.id = el.countryList[0].countryId;
        siteObject.check = false;

        //site data
        values.display_name = el.userSiteId + " " + el.name;
        values.data_id = el.userSiteId;
        values.check = false;
        siteObject.values.push(values);
        sitesArray.push(siteObject);
      });

      //formatted Sites Array
      const formattedSites = [];
      let index = 0;
      sitesArray.map(el => {
        if (index === 0) {
          formattedSites.push(el);
        } else {
          let flag = false;
          formattedSites.map(items => {
            if (el.name === items.name) {
              flag = true;
              items.values.push(el.values[0]);
            }
          });
          if (flag === false) {
            formattedSites.push(el);
          }
        }
        index++;
      });
      this.sites = formattedSites;
      this.siteDataLoaded = true;
    },
    getSitesCount(data) {
      this.sites = data;
      const count = this.$refs.childComponent.getSelectedSitesCount();
      if (count > 0) {
        this.isSiteSelected = true;
      } else {
        this.isSiteSelected = false;
      }
    },
    updateData(data) {
      if (data === true) {
        this.isSiteSelected = true;
        this.sites.map(el => {
          el.check = true;
          el.values.map(item => {
            item.check = true;
          });
        });
      } else {
        this.isSiteSelected = false;
        this.sites.map(el => {
          el.check = false;
          el.values.map(item => {
            item.check = false;
          });
        });
      }
    },
    closeEditMaterial() {
      this.validFileType = true;
      this.validFileSize = true;
      this.isFileSelected = false;
      this.validmaterialNameValue = false;
      this.materialName = false;
      this.sites.map(el => {
        el.check = false;
        el.values.map(item => {
          item.check = false;
        });
      });
      this.editMaterial = {
        name: "",
        file: "",
        siteName: [],
        allSitesSelected: false
      };
      this.fileName = "";
      document.getElementById("filePhoto").value = "";
      this.validmaterialNameValue = this.materialName = false;
      this.$root.$emit("close_material", true);
      window.$("#add_material_pop").modal("hide");
    },
    async editMaterialFiles(event) {
      this.isFileSelected = true;
      let file = event.target.files[0];
      this.fileType = file.type;
      this.fileName = "";

      this.fileExtensionType = file.name.substr(file.name.lastIndexOf(".") + 1);
      this.fileExtensionType = this.fileExtensionType.toLowerCase();
      if (["png", "jpeg", "jpg", "mp4", "pdf"].includes(this.fileExtensionType) || this.fileType.includes("document") || this.fileType.includes("spreadsheetml.sheet")) {
        this.validFileType = true;
        if (file.size < 104857600) {
          this.validFileSize = true;
        } else {
          this.validFileSize = false;
          return "error";
        }
      } else {
        this.validFileType = false;
        this.fileName = event.target.files[0].name;
        this.$toastr.error("Invalid file type " + this.fileExtensionType + ".");
        return "error";
      }

      this.fileName = event.target.files[0].name;

      //fileURL = URL.createObjectURL(event.target.files[0]);
      this.editMaterial.file = event.target.files[0];
      const data = {
        studyId: this.studyId,
        fileName: event.target.files[0].name,
        preSigendUrl: ""
      };

      await this.$api.getPresignedURL(data).then(response => {
        const uploadUrl = response.body.preSignedUrl;
        this.filePath = response.body.s3Path;
        if (file) {
          if (file.size < 104857600) {
            const url = uploadUrl;
            this.$forceUpdate();
            this.xmlHTTP = new XMLHttpRequest();
            this.xmlHTTP.open("PUT", url, true);
            this.xmlHTTP.setRequestHeader("Content-Type", file.type);
            this.xmlHTTP.setRequestHeader("clientId", localStorageService.getItem("clientId"));
            this.xmlHTTP.setRequestHeader("Authorization", localStorageService.getItem("token"));
            this.xmlHTTP.send(file);
          } else {
            this.$toastr.error("File size exceeds the maximum of 100 MB.");
            file = null;
          }
        }
      });
    },
    setSiteValue() {
      this.editMaterial.siteName = this.$store.state.materialSitesData;
    },
    validateMaterialData(editMaterial) {
      let isError = true;

      if (this.isFileSelected === false) {
        this.$toastr.error("Please select a file.");
        return isError;
      } else if (this.validFileType === false) {
        this.$toastr.error("Invalid file type " + this.fileExtensionType + ".");
        return isError;
      } else if (this.validFileSize === false) {
        this.$toastr.error("File size exceeds the maximum of 100 MB.");
        return isError;
      }

      this.validateName(editMaterial.name);

      if (this.validmaterialNameValue && editMaterial.name.length < 200) {
        this.$toastr.error("The filename field must be at least 1 character.");
        return isError;
      } else if (editMaterial.name && editMaterial.name.length > 200) {
        this.$toastr.error("Filename cannot exceed 200 characters in length.");
        return isError;
      }

      if ((this.canSysAdminAccess && this.resourceListFlag) || (this.canStudyAdminAccess && this.resourceListFlag) || (this.canSupportAccess && this.resourceListFlag)) {
        this.$toastr.error("Please select a site.");
        return isError;
      }

      isError = false;
      return isError;
    },
    async uploadMaterialData(editMaterialData) {
      if (this.validateMaterialData(editMaterialData)) {
        return;
      }

      if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock") {
        this.sitedata = [{ siteId: this.piRoleUniqueId, siteName: this.piRoleName }];
      } else {
        this.sitedata = this.$store.state.materialSitesData;
      }
      const material = {
        title: this.editMaterial.name,
        type: "material",
        studySiteMeta: this.sitedata,
        fileType: this.fileType,
        filePath: this.filePath,
        fileName: this.fileName,
        createdBy: this.user.id
      };

      //API Call
      await this.$api.addResourcesCreation(this.studyId, material).then(response => {
        if (response) {
          this.editMaterial = {
            name: "",
            file: "",
            siteName: "",
            allSitesSelected: ""
          };
          window.$("#add_material_pop").modal("hide");
          this.isFileSelected = false;
          this.fileName = "";
          this.validmaterialNameValue = false;
          this.materialName = false;
          this.$root.$emit("materialDataResponse");
          window.$("#upload-material-success-pop").modal({ backdrop: "static", keyboard: false }, "show");
          this.sites.map(el => {
            el.check = false;
            el.values.map(item => {
              item.check = false;
            });
          });
        }
      });
    },
    validateName(name) {
      if (!this.editMaterial.name || this.editMaterial.name.length > 200) {
        this.materialName = true;
        if (this.editMaterial && this.editMaterial.name && this.editMaterial.name.length > 200) {
          this.$toastr.error("Filename cannot exceed 200 characters in length.");
        }
      } else {
        this.materialName = false;
      }
      const linksPattern = new RegExp("^[a-zA-Z]{0}[a-zA-Z0-9]{0,199}[a-zA-Z0-9]");
      if (linksPattern.test(name) || name.trim().length != 0) {
        this.validmaterialNameValue = false;
      } else {
        this.validmaterialNameValue = true;
      }
    },
    handleImage(e) {
      const reader = new FileReader();
      reader.onload = function(event) {
        $(".uploader img").attr("src", event.target.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    },
    getParticularPIrole() {
      if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock") {
        this.$api.getSiteDetailsFact(this.studyId, this.user.siteIds[0]).then(response => {
          this.piRoleName = response.body.name;
          this.piRoleUniqueId = response.body.userSiteId;
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.upload-material-pop {
  width: 380px;
  padding: 0.4px 0 0;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}
.add-resource-name {
  font-family: "RobotoRegular";
  font-size: 20px;
  margin: 4px 0px 10px 2px;
  line-height: 1;
  padding: 0px;
  color: #666669;
}
.add-resource-type {
  width: 292px;
  position: relative;
  bottom: 2px;
  padding: 3px;
  font-family: "RobotoRegular";
  font-size: 14px;
  line-height: 1.43;
  color: #666669;
}

.top-padding {
  padding-top: 0px !important;
}

.checkbox {
  width: 18px;
  height: 18px;
  margin: 4.1px 12px 5.5px 0;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
}

.create-an-announcement {
  // width: 226px;
  height: 20px;
  // margin: 39px 37px 2.5px 259px;
  font-family: "RobotoRegular";
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
.file-error-style {
  font-size: 12px;
  color: #ff4848;
  position: relative;
}
.material-cancel-btn {
  width: 82px;
  height: 32px;
  margin: 0 0 0 18px;
  padding: 0px 0 0px;
  border-radius: 4px;
  font-family: "RobotoRegular";
  font-size: 14px;
  line-height: 1.43;
  color: #b0bac9;
  background-color: #ffffff;
}
.material-add-btn {
  width: 82px;
  height: 32px;
  margin: 0 0 0 6px;
  padding: 0px 0 0px;
  border-radius: 4px;
  background-color: #4c8ce4;
  font-family: "RobotoRegular";
  font-size: 14px;
  line-height: 1.43;
  text-align: center;
  color: #ffffff;
}

.upload-material {
  width: 343px;
  height: 225px;
  margin: 0 0 0.5px 3.5px;
  padding: 31.3px 0 6.6px !important;
  border: 4px solid #d3dfe4;
  padding-top: 40px;
  border-radius: 5px;
  border-style: dashed;
  text-align: center;
  //height: 225px;
  margin-bottom: 20px;
  margin-top: 25px;
}

.upload-file {
  color: #4c8ce4;
  visibility: hidden;
}

.upload-file-text {
  color: #4c8ce4;
  border: 2px solid #4c8ce4;
  font-size: 14px;
}
.upload-file-img {
  width: 50px;
  height: 32.8px;
}
.drag-file-text {
  margin-bottom: 15px !important;
  font-size: 14px;
  margin-top: 4px;
}
.acceptable-file-types {
  font-size: 10px;
  color: #959fa4;
  // padding-top: 9px;
  // margin-bottom: 9px;
  position: absolute;
  bottom: 4px;
  left: 27px;
}
.editfile_name {
  color: #4c8ce4;
  font-family: "RobotoRegular";
  font-size: 12px;
  font-weight: bold;
  line-height: 1.67;
}
.inputWrapper {
  overflow: hidden;
  position: relative;
  cursor: pointer;
}
.material-cancel-add {
  float: right;
  margin: 13px 13px 10px 0px;
}

//common CSS
.edit-material-char-limit {
  float: right;
  font-family: "RobotoRegular";
  font-size: 9px;
  line-height: 2.22;
  text-align: center;
  color: #959fa4;
  height: 20px;
  margin: 3px 12px 0px 0px;
}

.edit-material-star {
  color: #ff4848;
  position: relative;
  left: 3px;
  bottom: 3px;
  margin-bottom: 0px !important;
}

.disabledbtn {
  background-color: #d3dfe4 !important;
  pointer-events: none;
  border: #d3dfe4 !important;
}
.links-label {
  height: 10px;
  font-family: "RobotoRegular";
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #666669;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
  padding-left: 0;
  position: relative;
  bottom: 14px;
}
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  padding: 0px;
}
button.resource-close {
  position: relative;
  left: 7px;
  bottom: 10px;
  font-size: 18px;
}
.links-title-box {
  width: 343px;
  height: 33px;
  margin: 2px 0px 17px 0px;
  padding: 1.9px 30px 0 10px;
  border-radius: 3px;
  border: solid 1px #d3dfe4;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
::placeholder {
  font-size: 14px;
  color: #c5d1d6;
}

//file upload
.uploader {
  position: relative;
  overflow: hidden;
  width: 300px;
  height: 350px;
  background: #f3f3f3;
  border: 2px dashed #e8e8e8;
}

#filePhoto {
  position: absolute;
  width: 348px;
  height: 230px;
  top: 0px;
  left: 0;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
}
</style>
